export interface LocationVisibilityChangeDTO {
  changedAtUtc                : string;
  changedByName?              : string | null;
  changedByPartnerCompanyId?  : number | null;
  changedByPartnerCompanyName?: string | null;
  companyId?                  : number | null;
  correlationId?              : string | null;
  effectiveFromUtc            : string;
  expiresUtc?                 : string | null;
  iccid?                      : string | null;
  newValue?                   : string | null;
  oldValue?                   : string | null;
  partnerLinkId?              : number | null;
  reason?                     : string | null;
  revertedAtUtc?              : string | null;
  scope                       : number;
  settingKey                  : string;
  settingKeyName              : string;
  source                      : number;
  sourceName                  : string;
  subjectName?                : string | null;
  userId?                     : number | null;
}

export enum eVisibilityChangeScope {
  Unknown    =0,
  Company    =1,
  User       =2,
  Sim        =3,
  PartnerLink=4
}
